'use strict';

var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var propTypes = require('./prop-types.js');
var isDefined = require('./is-defined.js');
var isString = require('./is-string.js');
var isObject = require('./is-object.js');
require('prop-types/factoryWithTypeCheckers');
require('./constants.js');
require('./is-defined-and-not-null.js');
require('./is-null.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _defineProperty__default = /*#__PURE__*/_interopDefaultCompat(_defineProperty);

/**
 * Create an attribute to an object.
 *
 * @function
 * @param {object} [parameter={}] - Object with 'value' and 'attribute'.
 * @param {string} [parameter.attribute] - Attribute to add.
 * @param {*} [parameter.value] - Value to add.
 * @returns {object} Returns an object with the attribute and value passed, empty object otherwise.
 * @example
 * const obj = {
 *  old: 23,
 *  ...createAttribute({ attribute: 'my-attr', value: 42 }),
 * };
 * // => { old: 23, 'my-attr': 42 }
 */

var createAttribute = function createAttribute() {
  var parameter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (isObject(parameter)) {
    var value = parameter.value,
        attribute = parameter.attribute;

    if (isString(attribute) && isDefined(value)) {
      return _defineProperty__default["default"]({}, attribute, value);
    }
  }

  return {};
};

createAttribute.HELPER_ID = 'Gearz.JsUtils.createAttribute';
createAttribute.returnType = propTypes.objectWithDescription('Returns an object with the attribute and value passed, empty object otherwise.');
createAttribute.parameterTypes = {
  parameter: propTypes.shapeWithDescription({
    attribute: propTypes.stringWithDescription('Name of the attribute to add.'),
    value: propTypes.anyWithDescription('Value of the attribute to add.')
  }, 'Settings to add an attribute.')
};
createAttribute.defaultParameters = {
  parameter: {}
};

module.exports = createAttribute;
